import { Clock } from 'lucide-react';
import { useCountdown } from '@/hooks/useCountdown';

interface WheelCountdownProps {
  nextResetAt: string | null;
  onExpired?: () => void;
}

export const WheelCountdown = ({ nextResetAt, onExpired }: WheelCountdownProps) => {
  const { formatted, isExpired } = useCountdown(nextResetAt);

  // Chamar callback quando expirar
  if (isExpired && onExpired) {
    onExpired();
  }

  if (isExpired) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-4 py-3">
      <div className="flex items-center gap-2 text-white/60 text-sm">
        <Clock className="w-4 h-4" />
        <span>Próximo giro grátis em:</span>
      </div>
      <div className="font-mono text-2xl font-bold text-white tracking-wider">
        {formatted}
      </div>
    </div>
  );
};
